import React, { useState } from "react";
import Modal from "../components/Modal";
import { useTranslation } from "react-i18next";


const Loyalty_program = () => {

  const LogoMarquee = ({
    speed = 48,     // mayor = más sutil/lento
    gapRem = 3,     // separación entre logos (rem)
  }) => {
    // Ajustes finos por marca (por si alguna es demasiado ancha/alta visualmente)
    // Puedes quitar/ajustar estas entradas si no las necesitas.
    const brandAdjust = {
      "Sushiexpress1.webp": "scale-90",
      "Elcosto.webp": "scale-90",
      "Grupotova.webp": "scale-90",
    };
  
    const logos = [
      // === 9 nuevos primero ===
      { src: "https://img.invupos.com/clauweb/Empresas/stevens.png", alt: "Stevens" },
      { src: "https://img.invupos.com/clauweb/Empresas/Powertranz.png", alt: "Powertranz" },
      { src: "https://img.invupos.com/clauweb/Empresas/Grand-deli-gourmet.png", alt: "Grand Deli Gourmet" },
      { src: "https://img.invupos.com/clauweb/Empresas/Olive-garden.png", alt: "Olive Garden" },
      { src: "https://img.invupos.com/clauweb/Empresas/sugoi.png", alt: "Sugoi" },
      { src: "https://img.invupos.com/clauweb/Empresas/Cafe%20duran.png", alt: "Café Durán" },
      { src: "https://img.invupos.com/clauweb/Empresas/Madison.png", alt: "Madison" },
      { src: "https://img.invupos.com/clauweb/Empresas/XING%20FU%20TANG.png", alt: "Xing Fu Tang" },
      { src: "https://img.invupos.com/clauweb/Empresas/Leto.png", alt: "Leto" },
  
      // === Los que ya tenías ===
      // { src: "https://img.invupos.com/clauweb/Partners/logos/cinnabon-1.webp", alt: "Cinnabon" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Sushiexpress1.webp", alt: "Sushi Express" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Elcosto.webp", alt: "El Costo" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Grupotova.webp", alt: "Grupo Tova" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/CredicorpBank_logo.webp", alt: "Credicorp Bank" },
      // { src: "https://img.invupos.com/clauweb/Partners/Tsugoi.webp", alt: "Tsugoi" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/FDCenter_logo.webp", alt: "FDCenter" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Bravapizza_logo.webp", alt: "Brava Pizza" },
    ];
  
    // Duplicamos dentro de UNA sola pista para loop perfecto sin “salto”
    const track = [...logos, ...logos];
  
    return (
      <div
        className="relative w-full overflow-hidden group"
        // máscara sutil para entradas/salidas suaves
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <style>{`
          @keyframes marqueeX {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            display: flex;
            align-items: center;
            width: max-content;
            animation: marqueeX var(--marquee-duration, 48s) linear infinite;
            will-change: transform;
          }
          .marquee-track > * + * { margin-left: ${gapRem}rem; } /* separación entre “cajas” */
          .paused { animation-play-state: paused; }
  
          /* Respeta reduce motion */
          @media (prefers-reduced-motion: reduce) {
            .marquee-track { animation: none !important; transform: none !important; }
          }
  
          /* Ajuste leve por viewport para elegancia */
          @media (min-width: 1024px) {
            .marquee-root { --marquee-duration: ${speed + 6}s; }
          }
          @media (max-width: 480px) {
            .marquee-root { --marquee-duration: ${Math.max(30, speed - 6)}s; }
          }
        `}</style>
  
        <div className="marquee-root">
          <div className={`marquee-track group-hover:paused`}>
            {track.map((logo, i) => {
              // detectar nombre de archivo para ajuste fino opcional
              const filename = logo.src.split("/").pop() || "";
              const tweak = Object.keys(brandAdjust).find(key =>
                filename.includes(key)
              );
              const scaleClass = tweak ? brandAdjust[tweak] : "";
  
              return (
                <div
                  key={i}
                  className="flex-shrink-0 flex items-center justify-center 
                             h-[68px] sm:h-[76px] lg:h-[86px]
                             w-[clamp(140px,12vw,240px)]" // caja uniforme
                >
                  <img
                    src={logo.src}
                    alt={logo.alt || ""}
                    loading="lazy"
                    className={`max-h-full max-w-full object-contain 
  
                      transition-all duration-300 ease-in-out
                      ${scaleClass}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const { t, i18n } = useTranslation();
  const [language, setLenguage] = useState("es");
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      {/* <section className="bg-gradient-to-b bg-gradient-to-b from-[#040309] via-[#171635] to-[#2A255B]">
        <div className="px-4 py-28 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:gap-32 lg:grid-cols-2 items-center">
            <div className="relative overflow-hidden lg:order-last order-last flex flex-col rounded-3xl drop-shadow-[0_10px_20px_rgba(236,57,42,0.25)]">
              <img
                alt="Lealtad"
                src="https://img.invupos.com/clauweb/Loyalty_program/loyalty-hero_1_s8ildz.png"
                className="w-[500px]"
              />
            </div>
            <div className="lg:py-28 text-left">
              <h1 className="text-7xl font-extrabold sm:text-9xl text-white">
                <span className="block">{t("claulealtaduppercase")}</span>
                <span
                  className="mt-4 w-full ml-auto px-12 py-4 rounded-r-full text-white lg:text-7xl text-5xl font-bold flex items-center justify-end"
                  style={{
                    background:
                      "linear-gradient(to right, white, #A9A8EE, #9290EA)",
                  }}
                >
                  {t("claulealtadtitlespan")}
                </span>
              </h1>
              <p className="mt-8 text-gray-100 text-2xl w-full tracking-normal leading-relaxed">
                {t("claulealtaddescription")}
              </p>
              <div className="mt-8">
                <button
                  class="inline-block rounded-full border border-[#fff] bg-[#fff] px-16 py-4 text-lg font-medium text-[#1F2331] hover:bg-transparent hover:text-[#fff] focus:ring-3 focus:outline-hidden"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  {t("claulealtadcta")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

<section className="relative w-full flex items-center overflow-hidden lg:pt-0 pt-10">
  
  {/* Fondo con zoom */}
  {/* <div
  className="absolute inset-0 bg-cover bg-center"
  style={{
    backgroundImage:
      "url('https://img.invupos.com/clauweb/Hero/bg%20%281%29.png')",
    width: "120%",
    height: "120%",
    top: "-10%",
    left: "-10%",
    animation: "subtleMotion 20s ease-in-out infinite alternate",
  }}
/> */}

  <div className="w-full max-w-screen-2xl mx-auto px-6">
    
    {/* 👇 Cambiamos proporción del grid */}
    <div className="grid lg:grid-cols-[46%_54%] items-center gap-10">

      {/* LEFT */}
      <div className="max-w-3xl z-10">

        <h1 className="text-4xl md:text-5xl xl:text-[65px] font-medium text-[#0B2B5C] leading-[1.15] mb-6">
        {t("LOYALTY_HERO_TITLE_LINE1")}{" "}
        <span className="text-[#EC392A] font-extrabold">
          {t("LOYALTY_HERO_TITLE_HIGHLIGHT")}
        </span>{" "}
        {t("LOYALTY_HERO_TITLE_LINE2")}
        </h1>

        <p className="text-gray-600 text-base md:text-lg mb-8 max-w-2xl">
        {t("LOYALTY_HERO_DESCRIPTION")}
        </p> 
        <button 
          onClick={() => {
            setIsOpen(true);
          }}
        className="bg-[#E73829] hover:bg-[#ff5a4c] transition text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg">
        {t("LOYALTY_HERO_BUTTON")}
        </button>
      </div>

      {/* RIGHT */}
      {/* <div className="relative flex justify-end">
        <img
          src="https://img.invupos.com/clauweb/Hero/Group%201597880418.png"
          alt="Clau App"
          className="w-[120%] max-w-none translate-x-10 drop-shadow-2xl"
        />
      </div> */}


<div className="relative flex justify-center lg:justify-center">

{/* 🎨 LÍNEAS */}
<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-3.png"
  alt=""
  className="
    absolute top-0 
    lg:left-auto lg:right-0 lg:translate-x-10
    w-[110%] sm:w-[115%] lg:w-[130%] max-w-none
    rotate-45
    animate-lineDrawBlue
  "
/>

<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-4.png"
  alt=""
  className="
    absolute top-0 
    lg:left-auto lg:right-0 lg:translate-x-10
    w-[110%] sm:w-[115%] lg:w-[130%] max-w-none
    rotate-45
    animate-lineDrawRed
  "
/>

{/* 🧱 IMAGEN 1 */}
<img
  src="https://img.invupos.com/clauweb/Loyalty_program/nueva%20invu%20pos%20-23%201.png"
  alt="Clau App"
  className="
    relative z-10
    w-[70%] sm:w-[50%] lg:w-[47%] max-w-none
    mx-auto
   lg:-left-10
    lg:translate-x-10
    opacity-0 animate-img1
    mb-8
  "
/>
</div>
    </div>
  </div>
</section>


<section>
        <div className="lg:mt-0 mt-10 mx-auto max-w-screen-2xl">
          <LogoMarquee speed={42} gapRem={2} />
        </div>
      </section>


      <section className="py-20 px-6">
      <div className="max-w-screen-2xl mx-auto">
        
        {/* Title */}
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-12 max-w-4xl">
          {t("LOYALTY_SETUP_TITLE")}
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          
          {/* Imagen con círculo */}
          <div className="relative flex justify-center items-center">
            
            {/* BACKGROUND CIRCLE */}
            <img
              src="https://img.invupos.com/clauweb/Hero/orange-circle.png"
              alt=""
              aria-hidden="true"
              className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] opacity-100 pointer-events-none"
              style={{ animation: "slowPulse 6s ease-in-out infinite" }}
            />

            {/* CENTER PHONE */}
            <div className="relative z-10 flex justify-center">
              <img
                src="https://img.invupos.com/clauweb/Loyalty_program/cover-1-loyalty.png"
                alt="App E-commerce"
                className="w-[280px] xl:w-[390px] drop-shadow-2xl"
              />
            </div>

          </div>

          {/* Texto grande */}
          <div className="space-y-6 text-gray-900 text-lg md:text-xl xl:text-2xl leading-relaxed">
            <p>• <strong>{t("LOYALTY_SETUP_ITEM_1_TITLE")}</strong> {t("LOYALTY_SETUP_ITEM_1_TEXT")}</p>
            <p>• <strong>{t("LOYALTY_SETUP_ITEM_2_TITLE")}</strong> {t("LOYALTY_SETUP_ITEM_2_TEXT")}</p>
            <p>• <strong>{t("LOYALTY_SETUP_ITEM_3_TITLE")}</strong> {t("LOYALTY_SETUP_ITEM_3_TEXT")}</p>
            <p>• <strong>{t("LOYALTY_SETUP_ITEM_4_TITLE")}</strong> {t("LOYALTY_SETUP_ITEM_4_TEXT")}</p>
          </div>

        </div>
      </div>
    </section>
{/* 
      <div className="px-4 py-16 mx-auto  md:max-w-full lg:max-w-screen-xl lg:px-8 lg:py-10">
        <div className="p-8 rounded-3xl sm:p-12 bg-[#F1F1F1]">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1d1d1f]">
            {t("claulealtadprogramtitle")}
          </h2>
          <div className="flex flex-col items-center justify-between lg:flex-row mt-8 rounded-3xl bg-[#F1F1F1] lg:gap-12">
            <div className="relative lg:w-1/2 mb-8 lg:mb-0 ">
              <img
                className="lg:w-full lg:h-96 rounded-2xl shadow-lg object-cover object-top"
                src="https://img.invupos.com/clauweb/Loyalty_program/Rectangle_161124221_cskgdz.png"
                alt="Combo del día"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent rounded-2xl flex items-end justify-center p-4">
                <p className="text-white text-2xl font-semibold">
                  {t("claulealtaduniquepromo")}
                </p>
              </div>
            </div>

            <div className="lg:max-w-xl lg:pl-10 p-8">
              <ul className="space-y-5 text-gray-700 text-2xl list-disc">
                <li>
                  <span className="font-bold ">
                    {t("claulealtadfeatureconfigsubtitle")}
                  </span>{" "}
                  <br /> {t("claulealtadfeatureconfigdecription")}
                </li>
                <li>
                  <span className="font-bold">
                    {t("claulealtadfeaturepointssubtitle")}
                  </span>{" "}
                  <br /> {t("claulealtadfeaturepointsdescription")}
                </li>
                <li>
                  <span className="font-bold">
                    {t("claulealtadfeaturenivelessubtitle")}
                  </span>{" "}
                  <br /> {t("claulealtadfeaturenivelesdescription")}
                </li>
                <li>
                  <span className="font-bold">
                    {t("claulealtadfeaturepromocionessubtitle")}
                  </span>{" "}
                  <br /> {t("claulealtadfeaturepromocionesdecription")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> */}

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-2xl  lg:px-8 lg:py-20">
        <h2 className="text-5xl sm:text-6xl text-[#1d1d1f] py-10 mb-8 md:mb-0 text-left md:text-center lg:text-left md:mb-6 lg:mb-0">
          {t("claulealtadbenefittitle")}{" "}
          <span className="hidden lg:inline">
            <br />
          </span>
          <span className="text-[#FE7066]">
            {t("claulealtadbenefittitlespan")}
          </span>
        </h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-5">
          <div className=" lg:px-8 relative md:col-span-2 lg:col-span-2 items-center flex  justify-center md:justify-center">
            <div className="max-w-xl relative w-full h-[260px] lg:ml-0 ml-10">
              <div className="absolute top-[-40px] left-[-40px] w-full h-full bg-[#FFE9E9] rounded-[2rem] z-0"></div>
              <div className="absolute top-[-20px] left-[-20px] w-full h-full bg-[#F58F87] rounded-[2rem] z-0"></div>

              {/* Tarjeta principal */}
              <div className="relative bg-[#FE7066] text-white rounded-[2rem] p-6 w-full h-full z-10 shadow-md">
                <div className="flex justify-between items-start">
                  <h2 className="text-4xl font-bold leading-tight">
                    {t("claulealtadpointsactiontitle")}
                  </h2>
                  <div className="bg-white text-rose-500 rounded-full p-2">
                    <svg
                      className="w-8 h-8"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17 7l-10 10M17 17V7H7"
                      />
                    </svg>
                  </div>
                </div>
                <p className="mt-4 text-white/90 leading-relaxed text-2xl">
                  {t("claulealtadpointsactiondescription")}
                </p>
              </div>
            </div>
          </div>
          <div className="grid gap-6 md:col-span-2 lg:col-span-3">
            <div>
              <img
                className="w-full h-auto"
                src="https://img.invupos.com/clauweb/Loyalty/Post%20para%20Instagram%20recordatorio%20frase%20no%20olvidar%20amarillo%20naranja%201.png"
                alt="Promoción"
              />
            </div>
            <div className="mt-8 text-center">
              <button
                class="inline-block rounded-full border border-[#FE7066] bg-[#FE7066] px-16 py-4 text-lg font-medium text-white hover:bg-transparent hover:text-[#FE7066] focus:ring-3 focus:outline-hidden"
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                {t("claulealtadpointscta")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 mx-auto md:max-w-full lg:max-w-screen-2xl lg:px-8">
        <div className="rounded-3xl sm:p-6 bg-[#F1F1F1]">
          <div className="flex flex-col lg:flex-row px-4 py-5">
            <div className="lg:w-1/2 content-center">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div className="border-2 border-[#2C2D84] rounded-xl px-4 py-6 bg-white">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {t("claulealtadlevelbronzetitle")}
                  </h3>
                  <p className="text-3xl font-extrabold text-[#2C2D84] mt-2">
                    x1
                  </p>
                  <p className="text-sm font-medium mt-2 text-black">
                    {t("claulealtadlevelbronzepoints")}
                  </p>
                </div>
                <div className="border-2 border-[#E63E2D] rounded-xl px-4 py-6 bg-white">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {t("claulealtadlevelsilvertitle")}
                  </h3>
                  <p className="text-3xl font-extrabold text-[#E63E2D] mt-2">
                    x3
                  </p>
                  <p className="text-sm font-medium mt-2 text-black">
                    {t("claulealtadlevelsilverpoints")}
                  </p>
                </div>
                <div className="border-2 border-[#F2A343] rounded-xl px-4 py-6 bg-white">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {t("claulealtadlevelgoldtitle")}
                  </h3>
                  <p className="text-3xl font-extrabold text-[#F2A343] mt-2">
                    x5
                  </p>
                  <p className="text-sm font-medium mt-2 text-black">
                    {t("claulealtadlevelgoldpoints")}
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-6 lg:mb-0 lg:w-1/2 lg:pr-10 content-start lg:px-12 lg:mt-0 mt-6">
              <div className="text-gray-500 text-xl space-y-3 md:col-span-1 tracking-normal leading-relaxed">
                <h2 className="text-4xl sm:text-4xl font-extrabold text-[#1d1d1f]">
                  {t("claulealtadlevelstitle")}
                </h2>
                <p>{t("claulealtadlevelsdescription")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 mx-auto md:max-w-full lg:max-w-screen-2xl lg:px-8 mt-12">
  
  {/* TITLE */}
  <div className="text-left max-w-[800px] ">
    <h2 className="text-5xl sm:text-6xl text-[#1d1d1f] py-10 md:mb-0 lg:mb-0 leading-tight">
      {t("claulealtaddatatitle")}
    </h2>
  </div>

  {/* === TOP: 2 GRÁFICAS === */}
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
    
    {/* GRÁFICA 1 (SIN CAMBIOS) */}
    <div className="bg-[#F8F8F8] rounded-2xl p-10 space-y-8">
      <h3 className="text-5xl text-[#FF9730]">
        {t("claulealtadpromoautomationtitle")}
      </h3>
      <p className="text-gray-500 text-2xl max-w-lg leading-relaxed">
        {t("claulealtadpromoautomationdescription")}
      </p>
      <div className="w-full max-w-xl h-[75px] flex overflow-hidden bg-[#EAEAEA] rounded-3xl">
        <div className="progress-stripes h-full"></div>
        <div className="w-[20%] h-full flex items-center justify-center text-[#f7901e] font-extrabold text-2xl">
          80%
        </div>
      </div>
    </div>

    {/* GRÁFICA 2 (SIN CAMBIOS) */}
    <div className="bg-[#F8F8F8] rounded-3xl p-6">
      <div className="flex justify-between items-start mb-6">
        <div className="flex items-center bg-white px-6 py-3 rounded-full shadow-sm">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#EB7162] text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler-chart-bar"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
              <path d="M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
              <path d="M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
              <path d="M4 20h14" />
            </svg>
          </div>
          <span className="ml-4 text-xl font-semibold text-[#1d1d1f]">
            Comparación de ventas
          </span>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <button className="text-[#1F2331] bg-[#EAEAEA] rounded-full px-2 py-1">
            12h
          </button>
          <button className="text-white bg-[#FF6551] rounded-full px-3 py-1 font-medium self-end">
            24h
          </button>
          <button className="text-[#1F2331] bg-[#EAEAEA] rounded-full px-2 py-1">
            A week
          </button>
          <button className="text-[#1F2331] bg-[#EAEAEA] rounded-full px-2 py-1">
            A month
          </button>
        </div>
      </div>

      <div className="relative h-60 border-l border-gray-200 pl-4">
        {["0%", "25%", "50%", "75%", "100%"].map((_, i) => (
          <div
            key={i}
            className="absolute w-full border-t border-gray-200"
            style={{ top: `${i * 25}%` }}
          />
        ))}

        {["2500", "1500", "1000", "500", "0"].map((label, i) => (
          <div
            key={i}
            className="absolute left-0 -translate-y-1/2 text-sm text-gray-400"
            style={{ top: `${i * 25}%` }}
          >
            {label}
          </div>
        ))}

        <div className="flex items-end justify-between h-full w-full pr-10 pl-6">
          {[
            "40%",
            "65%",
            "55%",
            "60%",
            "55%",
            "90%",
            "45%",
            "70%",
            "72%",
            "75%",
          ].map((h, i) => (
            <div
              key={i}
              className={`bar w-5 ${i === 5 ? "active" : ""}`}
              style={{ height: h }}
            />
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* === BOTTOM: CARDS (SIN CAMBIOS) === */}
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">

  <div className="bg-[#F8F8F8] rounded-2xl p-8">
      <h4 className="text-[#FF9730]  mb-2 text-2xl">
        {t("claulealtademailmarketingtitle")}
      </h4>
      <p className="text-gray-600 text-lg">
        {t("claulealtademailmarketingdescription")}
      </p>
    </div>

    <div className="bg-[#F8F8F8] rounded-2xl p-8">
      <h4 className="text-[#FF9730] mb-2 text-2xl">
        {t("claulealtadsurveys")}
      </h4>
      <p className="text-gray-600 text-lg">
        {t("claulealtadsurveysdescription")}
      </p>
    </div>
    
    <div className="bg-[#F8F8F8] rounded-2xl p-8">
      <h4 className="text-[#FF9730] mb-2 text-2xl">
        {t("claulealtadcustomerdatabase")}
      </h4>
      <p className="text-gray-600 text-lg">
        {t("claulealtadcustomerdatabasedescription")}
      </p>
    </div>

  </div>
</div>
      {isOpen && <Modal setIsOpen={setIsOpen} />}
    </>
  );
};

export default Loyalty_program;